export default __webpack_public_path__ + "static/media/shop.b8a330dc.png";